import {useFeatures} from '@/hooks/useFeatures/useFeatures';
import {useIsMobile} from '@ark/web';
import {Box} from '@mui/material';
import {ReactNode} from 'react';
import {useLocation} from 'react-router-dom';
import {Layout} from './Layout';
import {MobileLayout} from './MobileLayout/MobileLayout';
import {Sidebar} from './Sidebar/Sidebar';
import {SplitLayout} from './SplitLayout';
import {SubSidebar} from './SubSidebar/SubSidebar';

const LayoutShell = ({children}: {children: ReactNode}) => (
  <Box
    sx={{
      display: 'flex',
      backgroundColor: theme => theme.palette.background.paper,
    }}
  >
    <Sidebar />
    <SubSidebar />
    {children}
  </Box>
);

export const LayoutSwitch = () => {
  const [features] = useFeatures();
  const {pathname} = useLocation();
  const isMobile = useIsMobile('md');

  const hasSplitLayout =
    pathname.startsWith('/messages') &&
    features.ConversationLayout &&
    !isMobile;

  if (isMobile) {
    return <MobileLayout />;
  }
  if (hasSplitLayout) {
    return (
      <LayoutShell>
        <SplitLayout />
      </LayoutShell>
    );
  }
  return (
    <LayoutShell>
      <Layout />
    </LayoutShell>
  );
};
